// Cross-platform storage abstraction for web (localStorage) and mobile (Capacitor Storage)
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const StorageImpl = Capacitor.isNativePlatform()
  ? {
      get: async (key: string) => {
        const { value } = await Preferences.get({ key });
        return value ?? null;
      },
      set: async (key: string, value: string) => {
        await Preferences.set({ key, value });
      },
      remove: async (key: string) => {
        await Preferences.remove({ key });
      },
      clear: async () => {
        await Preferences.clear();
      },
    }
  : {
      get: async (key: string) => {
        return localStorage.getItem(key);
      },
      set: async (key: string, value: string) => {
        localStorage.setItem(key, value);
      },
      remove: async (key: string) => {
        localStorage.removeItem(key);
      },
      clear: async () => {
        localStorage.clear();
      },
    };

export const storage = StorageImpl;
